/**
 * @file コンポーネント：フル動画ページスレッドポップアップ DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { PopupThreadDetail } from "~/src/components/pages/Video/Video/PopupThreadDetail";
import { PopupThreadList } from "~/src/components/pages/Video/Video/PopupThreadList";
import { PopupThreadNewEdit } from "~/src/components/pages/Video/Video/PopupThreadNewEdit";
import { Popup } from "~/src/components/projects/Popup";

// スタイル読み込み
import {
    StyledPopupContainer,
    StyledPopupContent,
    StyledPopupThreadListContainer,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledPopupContainer>
            {props.isOpenPopupThread && (
                <Popup
                    content={[
                        <StyledPopupContent
                            key="content"
                            ref={props.refPopupContent}
                        >
                            {/* 一覧 */}
                            <StyledPopupThreadListContainer
                                className={
                                    props.currentPage === "list" && "is-show"
                                }
                            >
                                <PopupThreadList
                                    currentPage={props.currentPage}
                                    errorMessageList={props.errorMessageList}
                                    fnGetDatetimeAgo={props.fnGetDatetimeAgo}
                                    fnJump={props.fnJump}
                                    isOpenPopupThread={props.isOpenPopupThread}
                                    messageList={props.messageList}
                                    operationId={props.operationId}
                                    setCurrentPage={props.setCurrentPage}
                                    setErrorMessageList={
                                        props.setErrorMessageList
                                    }
                                    setMessageList={props.setMessageList}
                                    setPopupHeadline={props.setPopupHeadline}
                                    setSelectedThread={props.setSelectedThread}
                                />
                            </StyledPopupThreadListContainer>
                            {/* 詳細 */}
                            {props.currentPage === "detail" && (
                                <PopupThreadDetail
                                    currentPage={props.currentPage}
                                    fnGetDatetimeAgo={props.fnGetDatetimeAgo}
                                    fnJump={props.fnJump}
                                    messageDetail={props.messageDetail}
                                    operationId={props.operationId}
                                    selectedThread={props.selectedThread}
                                    setCurrentPage={props.setCurrentPage}
                                    setMessageDetail={props.setMessageDetail}
                                    setMessageList={props.setMessageList}
                                    setPopupHeadline={props.setPopupHeadline}
                                />
                            )}
                            {/* 新規作成、編集 */}
                            {(props.currentPage === "new" ||
                                props.currentPage === "edit") && (
                                <PopupThreadNewEdit
                                    currentPage={props.currentPage}
                                    operationId={props.operationId}
                                    selectedThread={props.selectedThread}
                                    setCurrentPage={props.setCurrentPage}
                                    setMessageDetail={props.setMessageDetail}
                                    setMessageList={props.setMessageList}
                                    setPopupHeadline={props.setPopupHeadline}
                                    setSelectedThread={props.setSelectedThread}
                                />
                            )}
                        </StyledPopupContent>,
                    ]}
                    headline={props.popupHeadline}
                    isFullHeight={true}
                    isOpen={props.isOpenPopupThread}
                    setIsOpen={props.setIsOpenPopupThread}
                />
            )}
        </StyledPopupContainer>
    );
};
